import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../common.module.scss";
import { Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import CustomInput from "../../../custom/custom-input/CustomInput";
import { toast } from "react-toastify";
import { acceptstatus, rejectstatus } from "../../../../mock";

const OrderDecisionClient = ({ item, onUpdateData, fetchOrderData }) => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectComment, setRejectComment] = useState("");
  const [commentError, setCommentError] = useState("");

  const updateStatusUnloading = () => {
    setLoading(true);
    const status = acceptstatus(item.status);
    Order.updateStatus(item.id, status)
      .then(() => {
        setLoading(false);
        if (status === "completed") {
          toast.success(t("orderInfo.orderDecision.completedOrderSuccess"));
        } else {
          toast.success(t("orderInfo.orderDecision.rejectUnloadingSuccess"));
        }
        fetchOrderData();
        onUpdateData();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error sending status:", error);
        toast.error(t("orderInfo.genericError"));
      });
  };

  const openRejectModal = () => {
    setRejectComment("");
    setCommentError("");
    setShowRejectModal(true);
  };

  const closeRejectModal = () => {
    setShowRejectModal(false);
    setRejectComment("");
    setCommentError("");
  };

  const handleCommentChange = (value) => {
    setRejectComment(value);
    if (commentError) setCommentError("");
  };

  const handleRejectSubmit = () => {
    if (!rejectComment.trim()) {
      setCommentError(t("orderInfo.orderDecisionClient.rejectReasonRequired"));
      return;
    }

    setLoading(true);
    const status = rejectstatus(item.status);
    Order.updateStatus(item.id, status, rejectComment.trim())
      .then(() => {
        setLoading(false);
        closeRejectModal();
        toast.success(t("orderInfo.orderDecision.rejectUnloadingModerationSuccess"));
        fetchOrderData();
        onUpdateData();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error(t("orderInfo.genericError"));
      });
  };

  const renderStatus = () => {
    if (item.status === "unloadingcargomoderation" || item.status === "completedbyexecutor") {
      return (
        <>
          <div className={cn(style.cargo_wrapper)}>
            <div className={cn(style.cargo_title, style.orders_title)}>
              {t("orderInfo.orderDecisionClient.unloadingModerationClientTitle")}
            </div>
            <div style={{ display: "flex", gap: "16px", width: "100%" }}>
              <CustomButton
                text={t("orderInfo.orderDecision.confirmButton")}
                style={{ flex: "1" }}
                onClick={updateStatusUnloading}
                isLoading={isLoading}
              />
              <CustomButton
                text={t("orderInfo.orderDecision.rejectButton")}
                style={{ flex: "1" }}
                onClick={openRejectModal}
                isLoading={isLoading}
                isWhite
              />
            </div>
          </div>

          {showRejectModal && (
            <div className={style.modalOverlay} onClick={closeRejectModal}>
              <div
                className={style.modalContent}
                style={{ width: "420px" }}
                onClick={(event) => event.stopPropagation()}
              >
                <h4>
                  {t("orderInfo.orderDecisionClient.rejectModalTitle")}
                  <span
                    style={{ cursor: "pointer", fontSize: "18px", lineHeight: 1, color: "inherit" }}
                    onClick={closeRejectModal}
                  >
                    x
                  </span>
                </h4>

                <p style={{ margin: 0, fontSize: "14px", color: "#6b7280", lineHeight: "20px" }}>
                  {t("orderInfo.orderDecisionClient.rejectModalDescription")}
                </p>

                <div style={{ width: "100%" }}>
                  <CustomInput
                    placeholder={t("orderInfo.orderDecisionClient.reuploadDocumentInBetterQuality")}
                    labelText={t("orderInfo.orderDecisionClient.rejectReasonLabel")}
                    inputType="text"
                    isBgGray={true}
                    value={rejectComment}
                    onChangeValue={handleCommentChange}
                    errorText={commentError}
                  />
                </div>

                <div style={{ display: "flex", gap: "12px", width: "100%" }}>
                  <CustomButton
                    text={t("orderInfo.orderDecisionClient.cancelButton")}
                    style={{ flex: "1" }}
                    onClick={closeRejectModal}
                    isWhite
                  />
                  <CustomButton
                    text={t("orderInfo.orderDecisionClient.confirmRejectButton")}
                    style={{ flex: "1" }}
                    onClick={handleRejectSubmit}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      );
    } else {
      return null;
    }
  };

  return renderStatus();
};

export default OrderDecisionClient;
